<template>
  <div class="qingsu-rate-list">
    <HomeList
      ref="list"
      :paramsKey="paramsKey"
      :getListApi="getRatelist"
      :params="homeListParams"
      :pageInfo="pageInfo"
    >
      <template>
        <EvaluateItem
          v-for="item in rateList"
          :key="item.id"
          :info="item"
        ></EvaluateItem>
      </template>
    </HomeList>
  </div>
</template>

<script>
import HomeList from 'component/platform/homepage/common/homeList.vue'
import EvaluateItem from 'component/platform/homepage/qingsuTeacher/evaluateItem.vue'
import homepageMixin from 'mixins/platfrom/homepageMixin.js'

export default {
  props: {},
  mixins: [homepageMixin],
  components: {
    HomeList,
    EvaluateItem
  },
  data() {
    return {
      paramsKey: {
        pageNo: 'page',
        pageSize: 'size',
        listPath: 'rate_list',
        sort_type: 'sort_type'
      },
      pageInfo: {
        page: 2,
        size: 20
      }
    }
  },
  computed: {
    qingsuRateInfo() {
      return this.$store.state.homepage.qingsuRateInfo
    },
    rateList() {
      return this.qingsuRateInfo.list
    },
    rateFinish() {
      return this.qingsuRateInfo.isFinish
    },
    homeListParams() {
      return {
        user_id: this.$route.params.userId,
        have_content: 1
      }
    }
  },
  mounted() {
    this.$refs.list.finished = this.rateFinish
  },
  methods: {
    getRatelist(params) {
      return this.$store.dispatch('homepage/fetchQingsuRate', params)
    },
    getRatelistWithParams() {
      this.$set(this.pageInfo, 'page', 1)
      this.$refs.list.listInfo.page = 2
      const params = { ...this.homeListParams, ...this.pageInfo, page: 1 }
      // 可能只有一页
      this.getRatelist(params).then(res => {
        const { code, data } = res
        if (code) return
        this.$refs.list.finished = data.rate_list.length <= this.pageInfo.size
      })
    }
  },
  watch: {
    // 兼容处理
    rateFinish(newVal) {
      newVal && (this.$refs.list.finished = newVal)
    }
  }
}
</script>

<style lang="scss" scoped>
.qingsu-rate-list {
  ::v-deep .yxl-more-new .btn {
    color: #ff745b;
  }
}
</style>
